import moment from "moment"

export const determinarMora = (acceptDate, limitDays) => {

    let hoy = moment();
    let diffAcceptDaywithToday = hoy.diff(moment(acceptDate, "DD/MM/YYYY"), 'days');
    let hasMora = false;
    let diasMora = 0;

    if ((diffAcceptDaywithToday + 1) > limitDays) {

        console.log('Usuario presenta mora');

        diasMora = diffAcceptDaywithToday - limitDays;
        hasMora = true;

        console.log("dias en mora", diasMora);
    }

    return {
        hasMora, diasMora
    }

}


export const determinarMora2 = (payDayLimit) => {

    let hoy = moment();
    let diffPaydayLimit = hoy.diff(moment(payDayLimit, 'DD/MM/YYYY'), 'days');

    let hasMora = false;
    let diasMora = 0;

    if ((diffPaydayLimit) > 0) {
        console.log('Usuario presenta mora');
        diasMora = diffPaydayLimit;
        hasMora = true;
        console.log("dias en mora", diasMora);
    }
    
    return {
        hasMora, 
        diasMora
    }

}